import React from 'react';
import { getFormattedPercent, getFormattedNumber } from '../../../../Util/numberFormats';
import CardIcon from './Card/CardIcon';
import styles from './Card/Card.module.css';

const Metric = ({
	prevValue,
	value,
	evolution,
	isFavorable,
	findingType,
	translatedDescription
}) => {

	//const showEvolutionIcon = (prevValue !== 0 && value !== 0);

	const formattedEvolution = () => {
		//let ellips = '';
		const displayedEvolution = evolution;

		// if (evolution >= 100) {
		// 	displayedEvolution = 100;
		// 	ellips = '>\u00A0';
		// } else if (evolution < -100) {
		// 	displayedEvolution = -100;
		// 	ellips = '<\u00A0';
		// }

		if (prevValue === 0) {
			return 'Up after falling to 0';
		}

		if (value === 0) {
			return 'Dropped to 0';
		}

		if (evolution >= 1) {
			return 'x' + getFormattedNumber(displayedEvolution + 1, 1);
		}

		if (evolution <= -1) {
			return '÷' + getFormattedNumber((displayedEvolution * -1) + 1, 1);
		}

		//return ellips + getFormattedPercent(displayedEvolution * 100, 2, true, true);
		return getFormattedPercent(displayedEvolution * 100, 2, true);
	};

	return (
		<>
			<div className={styles.metricItemValueTitle}>
				{translatedDescription}
			</div>
			<div className={styles.metricItemValueEvo}>
				{formattedEvolution()}
				<CardIcon
					findingType={findingType}
					favorableness={isFavorable}
				/>
			</div>
		</>
	);
};

export default Metric;
